import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";

import { ContentHolder, Loading } from "commons";

import { NewsList } from "./NewsList";

function NewsContainerComponent({ newsItems, newsError }) {
    return (
        <ContentHolder>
            <BigLoading suppressClassNameWarning displayWhen={!!newsItems || !!newsError} size={25}>
                <NewsList newsItems={newsItems} newsError={newsError} />
            </BigLoading>
        </ContentHolder>
    );
}

export const BigLoading = styled(Loading)`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
`;

NewsContainerComponent.propTypes = {
    newsItems: PropTypes.array,
    newsError: PropTypes.string
};

const mapStateToProps = state => ({
    newsItems: state.news.newsItems,
    newsError: state.news.newsError
});

export const NewsContainer = connect(mapStateToProps)(NewsContainerComponent);
